export default __webpack_public_path__ + "static/media/top.bf0d9bf1.svg";